module.exports = __webpack_public_path__ + "img/1.8c4ce7fd.jpg";